import { axiosApi } from "../packages/axiosRequests";

export const statusList = ["active", "pending", "deleted"];
export const roleList = ["super-administrator", "administrator", "user"];
export const namespaceList = ["global", "south-africa", "kenya", "kuwait"];

export async function getUsers(
  { email, namespace, role, status },
  { limit, page }
) {
  const {
    data: {
      data,
      meta: { pagination, search },
    },
  } = await axiosApi.get(`/api/users`, {
    params: {
      page: page,
      limit: limit,

      email: email,
      status: status,
      role: role,
      namespace: namespace,
    },
  });
  console.log(pagination);
  console.log(search);
  return {
    users: data,
    pagination,
  };
}

export async function checkEmailAddress(email) {
  if (email) {
    const { data } = await axiosApi.get(`/api/email/${email}`);
    return data;
  }
  return false;
}

export async function getUserById(id) {
  console.log(id);
  const { data } = await axiosApi.get(`/api/user/${id}`);
  return data;
}

export async function updateUserById(id, values) {
  return axiosApi.put(`/api/user/${id}`, values);
}

export async function createUser(values) {
  return axiosApi.post(`/api/user/create`, values);
}
